import * as React from "react";
import { AuthApi } from "../api/authApi";
import { ISecurity } from "../models";
import { ApiService } from "qccat-ui/api/apiService";
import { useNavigate } from "react-router-dom";


interface IProps {
	oneTimeToken: string;
	apiService: ApiService;
	failedAuthUrl: string;
	successAuthRoute: string;
	storeAuthenticatedUser: (security: ISecurity) => void;
}

function Auth({ oneTimeToken, apiService, failedAuthUrl, successAuthRoute, storeAuthenticatedUser }: IProps) {

	let decodedOneTimeToken = decodeURIComponent(oneTimeToken);
	let authApi = new AuthApi(apiService);
	let navigate = useNavigate();

	const [message, setMessage] = React.useState("Authenticating...")
	
	React.useEffect(() => {
		const authenticate = async () => {
			
			try {
				const security = await authApi.authenticate(decodedOneTimeToken) as ISecurity;
				storeAuthenticatedUser(security);
				navigate(successAuthRoute, { replace: true });
			} catch (error) {
				console.error(error);
				setMessage(`Failed to authenticate! The error was: ${error.message}`);
				// window.location.href = failedAuthUrl;
			}
		}

		authenticate();
	
	});

	return (
		<>
			{message}
		</>

	)
}

export { Auth };